import { render, staticRenderFns } from "./InstantApp.vue?vue&type=template&id=76964d90&scoped=true"
import script from "./InstantApp.vue?vue&type=script&lang=js"
export * from "./InstantApp.vue?vue&type=script&lang=js"
import style0 from "./InstantApp.vue?vue&type=style&index=0&id=76964d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76964d90",
  null
  
)

export default component.exports